import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c2ca3fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "search-form"
}
const _hoisted_2 = { class: "search-form__scrollable" }
const _hoisted_3 = { class: "search-form__container" }
const _hoisted_4 = {
  key: 0,
  class: "search-form__intro"
}
const _hoisted_5 = { class: "search-form__information" }
const _hoisted_6 = { class: "search-form__title" }
const _hoisted_7 = { class: "search-form__buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "button-icon",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_QuestionFormNavigation = _resolveComponent("QuestionFormNavigation")!
  const _component_FinishQuestionForm = _resolveComponent("FinishQuestionForm")!

  return (!_ctx.isFinished)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.currentFormType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", null, " Perguntas: " + _toDisplayString(_ctx.currentContent.searchForm?.numberOfQuestionsForm), 1)
                  ]),
                  _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.currentContent.title), 1),
                  _createVNode(_component_TUIViewer, {
                    "model-value": _ctx.currentContent.description
                  }, null, 8, ["model-value"]),
                  _withDirectives(_createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "search-form__button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickStart && _ctx.onClickStart(...args)))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formButton), 1),
                      _hoisted_8
                    ])
                  ], 512), [
                    [_vShow, _ctx.showStartButton]
                  ])
                ]))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeComponent), {
                  key: _ctx.currentQuestion.question.id,
                  ref: "questionComponent",
                  question: _ctx.currentQuestion,
                  "current-page": _ctx.currentPage,
                  "total-pages": _ctx.totalPages,
                  disabled: _ctx.isAnswered
                }, null, 8, ["question", "current-page", "total-pages", "disabled"]))
          ])
        ]),
        (_ctx.currentPage > 0 && _ctx.currentQuestion?.question)
          ? (_openBlock(), _createBlock(_component_QuestionFormNavigation, {
              key: 0,
              class: "search-form__footer",
              "current-page": _ctx.currentPage,
              "total-pages": _ctx.totalPages,
              "question-form": _ctx.currentQuestion.question,
              "question-type": _ctx.currentFormType ?? 0,
              stars: _ctx.currentFormType === 1 ? _ctx.questionComponent?.getStars?.() : 0,
              single: 
        _ctx.currentFormType === 2 ? _ctx.questionComponent?.getSelected?.() : null
      ,
              multi: 
        _ctx.currentFormType === 3 ? _ctx.questionComponent?.getMultiAnswers?.() : []
      ,
              text: _ctx.currentFormType === 4 ? _ctx.questionComponent?.getAnswerText?.() : '',
              onGoNext: _ctx.onClickNext,
              onGoPrevious: _ctx.onClickPrevious
            }, null, 8, ["current-page", "total-pages", "question-form", "question-type", "stars", "single", "multi", "text", "onGoNext", "onGoPrevious"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(_component_FinishQuestionForm, { key: 1 }))
}